const pt = {
  // Navbar
  nav_home: 'Página Inicial',
  nav_trader: 'VPS Trader',
  nav_trader_all: 'Ver todos os planos',
  nav_trader_br: 'VPS Trader BR',
  nav_trader_uk: 'VPS Trader UK',
  nav_trader_us: 'VPS Trader US',
  nav_dev: 'VPS Devs',
  nav_dev_all: 'VPS para Desenvolvedores',
  nav_personal: 'VPS Pessoal',
  nav_personal_all: 'VPS para Uso Pessoal',
  nav_corporate: 'VPS Empresa',
  nav_enterprise: 'VPS Empresa',
  nav_company: 'Empresa',
  nav_about: 'Quem Somos',
  nav_datacenter: 'Data Center',
  nav_contact: 'Contato',
  nav_client_area: 'Área do Cliente',
  nav_hire: 'Contratar Agora',
  // Plans table
  plans_processor: 'Processador',
  plans_cores: 'Cores/Núcleos',
  plans_memory: 'Memória',
  plans_disk: 'Disco',
  plans_traffic: 'Tráfego',
  plans_value: 'Valor',
  plans_hire: 'Contratar',
  plans_popular: 'Popular',
  plans_unlimited: 'Ilimitado',
  plans_footer_note: '* Todos os planos incluem setup gratuito, suporte 24/7 em PT-BR e EN, proteção Anti-DDoS. Preços em BRL com impostos inclusos.',
  // Footer
  footer_about: 'Especialistas em VPS desde 2008. Infraestrutura de alta performance para traders, desenvolvedores e empresas no Brasil e no mundo.',
  footer_trader: 'VPS Trader',
  footer_solutions: 'Soluções',
  footer_company: 'Empresa',
  footer_rights: 'Todos os direitos reservados.',
  footer_systems: 'Todos os sistemas operacionais',
  // Common
  btn_specialist: 'Falar com Especialista',
  btn_doubt: 'Ficou com dúvidas?',
  choose_location: 'Ver também:',
  datacenter_label: 'Datacenter',
  latency_label: 'Latência média',
  exchange_label: 'Bolsas / Corretoras',
};

export default pt;
